import { iframeStep } from './iframeStep';
import { infoStep } from './infoStep';

export const imunity = {
  namespaced: true,
  modules: {
    iframeStep,
    infoStep
  }
};
